export const messages = {
    en: {
      common: {
        search: 'Search',
        reset: 'Reset',
        operation: 'Operation',
        edit: 'Edit',
        add: 'Add',
        addChild: 'AddChild',
        view: 'View',
        delete: 'Delete',
        confirm: 'Confirm',
        cancel: 'Cancel',
        none: 'None',
        close: 'Close',
        back: 'Back',
        warning: 'Warning',
        deleteConfirm: 'Are you sure to delete this record?',
        confirmDelete: 'confirm delete',
        confirmExit: 'confirm exit',
        deleteSuccess: 'Delete successfully',
        selectBtn: 'Select',
        select: 'Select',
        submit: 'Submit',
        upload:'Upload',
        chooseDate: 'Choose Date',
        download: 'Download',
        queryCondition: 'Query Condition',
        detail: 'Detail',
        save:'Save',
        update:'Update',
        createTime:'Create Time',
        document:'Document',
        resetPwdSuccess: 'Reset password successfully, new password is {pwd}, please change it in time',
        female: 'Female',
        male: 'Male',
        all: 'All',
        refresh: 'Refresh',
        export: 'Export',
        query: 'Query',
        yes: 'Yes',
        no: 'No',
        status: 'Status',
        enabled: 'Enabled',
        disabled: 'Disabled',
        import: 'Import',
        remark: 'Remark',
        hour:'hour',
        more:'More',
        tip:'Tip',
        selectFile:'Select File',
        change:'Change',
        print:'Print',
        year:'Year',
        month:'Month',
        examine:'Examine',
        audit:'Audit',
        choose:'Choose',
        submitSuccess:'Submit successfully',
        submitFailed:'Submit failed',
        saveSuccess:'successfully',
        operationSuccess:'Operation successfully',
        operationFailed:'Operation failed',
        noData:'No Data',
        file:'File',
        hide:'Hide',
        viewDetail:'View Detail',
        yuan:'yuan',
        process:'Process',
        jpgOnly:'Only JPG files are allowed',
        sizeLimit:'File size must be less than 2MB',
        required:'Required',
        invalid:'Invalid',
        explanation:'Explanation',
        manage:'Manage',
        monday: 'Monday',
        tuesday: 'Tuesday',
        wednesday: 'Wednesday',
        thursday: 'Thursday',
        friday: 'Friday',
        saturday: 'Saturday',
        sunday: 'Sunday',
        map:'Map'
      }
    },
    zh: {
      common: {
        search: '搜索',
        reset: '重置',
        operation: '操作',
        edit: '编辑',
        add: '添加',
        addChild: '添加',
        view: '查看',
        delete: '删除',
        confirm: '确定',
        cancel: '取消',
        none: '无',
        close: '关闭',
        back: '返回',
        warning: '警告',
        deleteConfirm: '确定要删除这条记录吗？',
        confirmDelete: '确定删除',
        confirmExit: '确定退出',
        deleteSuccess: '删除成功',
        selectBtn: '选择',
        select: '选择',
        submit: '提交',
        upload:'上传',
        chooseDate: '选择日期',
        download: '下载',
        queryCondition: '查询条件',
        detail: '详情',
        save:'保存',
        update:'更新',
        createTime:'创建时间',
        document:'文档',
        resetPwdSuccess: '修改密码成功，密码为{pwd}请及时修改密码',
        female: '女',
        male: '男',
        all: '全部',
        refresh: '刷新',
        export: '导出',
        query: '查询',
        yes: '是',
        no: '否',
        status: '状态',
        enabled: '启用',
        disabled: '禁用',
        import: '导入',
        remark: '备注',
        hour:'时',
        more:'更多',
        tip:'提示',
        selectFile:'选择文件',
        change:'变更',
        print:'打印',
        year:'年',
        month:'月',
        examine:'审核',
        audit:'审核',
        choose:'选择',
        submitSuccess:'提交成功',
        submitFailed:'提交失败',
        saveSuccess:'成功',
        operationSuccess:'操作成功',
        operationFailed:'操作失败',
        noData:'暂无数据',
        file:'附件',
        hide:'隐藏',
        viewDetail:'查看详情',
        yuan:'元',
        process:'处理',
        jpgOnly:'只允许上传JPG文件',
        sizeLimit:'文件大小必须小于2MB',
        required:'必填',
        invalid:'无效',
        explanation:'说明',
        manage:'管理',
        monday:'星期一',
        tuesday:'星期二',
        wednesday:'星期三',
        thursday:'星期四',
        friday:'星期五',
        saturday:'星期六',
        sunday:'星期日',
        map:'地图'
      }
    }
  } 